var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"deposit"},_vm._l((_vm.payTypeList),function(item,index){return _c('deposit-card',{key:index,attrs:{"pay-item":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }